import Table from "rc-table";
import { format } from "date-fns";

export const Rctable = ({ data }) => {
  const columns = [
    {
      title: "ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 40,
    },
    {
      title: "First Name",
      render: ({ user: { first_name } }) => first_name,
      key: "first_name",
      width: 100,
    },
    {
      title: "Last Name",
      render: ({ user: { last_name } }) => last_name,
      key: "last_name",
      width: 100,
    },
    {
      title: "Email",
      render: ({ user: { email } }) => email,
      key: "email",
      width: 200,
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
    },
    {
      title: "Date Joined",
      render: ({ user: { date_joined } }) =>
        format(new Date(date_joined), "yyyy-MM-dd"),
      key: "date_joined",
      width: 150,
    },
    {
      title: "Hobbies",
      dataIndex: "hobbies",
      key: "hobbies",
      width: 200,
    },
    {
      title: "Referred by",
      dataIndex: "referred_by",
      key: "referred_by",
      width: 100,
    },
    {
      title: "Newsletter",
      render: ({ newsletter }) => String(newsletter),
      key: "newsletter",
      width: 100,
    },
  ];
  if (!data) {
    return <div />;
  }

  return <Table columns={columns} data={data} tableLayout="auto" />;
};
